<div class="sol-navbar-header">
  <div class="sol-navbar-header-logo"></div>
  <div class="sol-navbar-header-toggle">
    <button class="sol-navbar-icon-button" (click)="onToggleNavbar($event)">
      <sol-icon [name]="dockToggleIcon$()" />
    </button>
  </div>
</div>
@if (appsVisible$()) {
  <div class="sol-navbar-app-container">
    @if (appsDropdownVisible$()) {
      <div class="sol-navbar-app" [class.sol-navbar-app-selected]="appHover$()" (click)="onAppClick($event)">
        <sol-icon [name]="appDisplayIcon$() ?? SolIcon.application" />
        <div class="sol-navbar-app-name">{{ appDisplayName$() | translate }}</div>
        <sol-icon [name]="SolIcon.chevrons_vertical" class="sol-icon-20" />
      </div>
    } @else {
      <div class="sol-navbar-app sol-navbar-app-readonly">
        <sol-icon [name]="appDisplayIcon$() ?? SolIcon.application" />
        <div class="sol-navbar-app-name">{{ appDisplayName$() | translate }}</div>
      </div>
    }
  </div>
}
<div class="sol-navbar-menu-scroll-container">
  <div class="sol-navbar-menu-scroll-content">
    @if (loading$()) {
      <sol-loader [loader]="SolLoader.ofList(6, 1).withMargin('0')" />
    } @else {
      <!-- items -->
      @for (item of menu$(); track item.id) {
        @if (item.hasAuthority) {
          <sol-navbar-item
            [item]="item"
            [level]="0"
            [activeRouteIds]="activeRouteIds$()"
            [expandedIds]="expandedIds$()"
            (expanded)="onExpanded($event)"
            (hoverPreview)="onHoverPreview($event)"
            (hoverPreviewClose)="closePopoverMenu()"
          />
        }
      }
    }
  </div>
</div>
<div class="sol-navbar-footer">
  <div class="sol-navbar-footer-buttons">
    @for (button of systemButtons$(); track button.id) {
      <sol-badge [badge]="button.badge">
        <button
          class="sol-navbar-icon-button"
          [class.sol-navbar-icon-button-selected]="activeRouteIds$().includes(button.id)"
          (click)="onSystemClick(button.id, $event)"
          (auxclick)="onSystemClick(button.id, $event, true)"
        >
          <sol-icon [name]="button.icon" />
        </button>
      </sol-badge>
    }
  </div>
  <div class="sol-navbar-footer-account">
    <button class="sol-button-menu-account" (click)="onAccountClick($event)">
      <div class="sol-button-menu-account-avatar">{{ initials$() }}</div>
      <div class="sol-button-menu-account-name">{{ name$() }}</div>
      <div class="sol-button-menu-account-icon">
        <sol-icon [name]="SolIcon.chevrons_vertical" class="sol-icon-20" />
      </div>
    </button>
  </div>
</div>
